export default __webpack_public_path__ + "65ceb431c46b10b4e08167150bb03e35.woff";